import {Controller} from '@stimulus/core'
import HSMask from '../../../../vendor/front/js/hs.mask'

require("jquery-mask-plugin/dist/jquery.mask")
require("../../../../vendor/front/js/hs.core")

// data-controller='hs--mask'

export default class extends Controller {
  connect() {
    $.HSCore.components.HSMask.init($(this.element))
  }
}
